import React from "react";
import UserList from "../../entities/userList/UserList";

export default function MainPage() {
  return (
    <section className="container">
      <UserList />
    </section>
  );
}
